<template>
    <div>
        <v-row>
            <v-col cols="12" md="5" align="left">
                <div class="subtitle-2"><b>BuyerTaxID</b></div>
                <v-text-field
                    :value.sync="BuyerTaxID"
                    @change="(val) => onchange('BuyerTaxID',val)"
                    outlined
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" align="left">
                <div class="subtitle-2"><b>BuyerName</b></div>
                <v-text-field
                    :value.sync="BuyerName"
                    @change="(val) => onchange('BuyerName',val)"
                    outlined
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mt-n8">
            <v-col cols="12" md="6" align="left">
                <div class="subtitle-2"><b>BuyerBranchName</b></div>
                <v-text-field
                    :value.sync="BuyerBranchName"
                    @change="(val) => onchange('BuyerBranchName',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" align="left">
                <div class="subtitle-2"><b>BuyerBranchNo</b></div>
                <v-text-field
                    :value.sync="BuyerBranchNo"
                    @change="(val) => onchange('BuyerBranchNo',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mt-n8">
            <v-col cols="12" md="10" align="left">
                <div class="subtitle-2"><b>BuyerAddress</b></div>
                <v-text-field
                    :value.sync="BuyerAddress"
                    @change="(val) => onchange('BuyerAddress',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mt-n8">
            <v-col cols="12" md="6" align="left">
                <div class="subtitle-2"><b>BuyerBuildingName</b></div>
                <v-text-field
                    :value.sync="BuyerBuildingName"
                    @change="(val) => onchange('BuyerBuildingName',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" align="left">
                <div class="subtitle-2"><b>BuyerBuildingNo</b></div>
                <v-text-field
                    :value.sync="BuyerBuildingNo"
                    @change="(val) => onchange('BuyerBuildingNo',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mt-n8">
            <v-col cols="12" md="3" align="left">
                <div class="subtitle-2"><b>BuyerStreetName</b></div>
                <v-text-field
                    :value.sync="BuyerStreetName"
                    @change="(val) => onchange('BuyerStreetName',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" align="left">
                <div class="subtitle-2"><b>BuyerDistinct</b></div>
                <v-text-field
                    :value.sync="BuyerDistinct"
                    @change="(val) => onchange('BuyerDistinct',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" align="left">
                <div class="subtitle-2"><b>BuyerCity</b></div>
                <v-text-field
                    :value.sync="BuyerCity"
                    @change="(val) => onchange('BuyerCity',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mt-n8">
            <v-col cols="12" md="4" align="left">
                <div class="subtitle-2"><b>BuyerProvince</b></div>
                <v-text-field
                    :value.sync="BuyerProvince"
                    @change="(val) => onchange('BuyerProvince',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" align="left">
                <div class="subtitle-2"><b>BuyerPostalCode</b></div>
                <v-text-field
                    :value.sync="BuyerPostalCode"
                    @change="(val) => onchange('BuyerPostalCode',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" align="left">
                <div class="subtitle-2"><b>BuyerCountryCode</b></div>
                <v-text-field
                    :value.sync="BuyerCountryCode"
                    @change="(val) => onchange('BuyerCountryCode',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mt-n8">
            <v-col cols="12" md="5" align="left">
                <div class="subtitle-2"><b>BuyerPhoneNumber</b></div>
                <v-text-field
                    :value.sync="BuyerPhoneNumber"
                    @change="(val) => onchange('BuyerPhoneNumber',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" align="left">
                <div class="subtitle-2"><b>BuyerElectronicEmail</b></div>
                <v-text-field
                    :value.sync="BuyerElectronicEmail"
                    @change="(val) => onchange('BuyerElectronicEmail',val)"
                    outlined
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
        </v-row>
        
    </div>
</template>
<script>
  export default {
    props: ['onchange','disabled'
        ,'BuyerTaxID'
        ,'BuyerName'
        ,'BuyerBranchName'
        ,'BuyerBranchNo'
        ,'BuyerAddress'
        ,'BuyerBuildingName'
        ,'BuyerBuildingNo'
        ,'BuyerStreetName'
        ,'BuyerDistinct'
        ,'BuyerCity'
        ,'BuyerProvince'
        ,'BuyerPostalCode'
        ,'BuyerCountryCode'
        ,'BuyerPhoneNumber'
        ,'BuyerElectronicEmail'
    ]
  }
</script>